import { ValueOf } from '../value-of';
import { ItemIdDescricao } from '../item-id-descricao';

export type IdItem = string | number;

export class Item implements ValueOf<IdItem>, ItemIdDescricao {
    constructor(
        public id: IdItem,
        public label: string
    ) {}

    get descricao(): string {
        return this.label;
    }

    valueOf(): IdItem {
        return this.id;
    }
}
